import ArrowRight from './src/arrow-right-combined';
export default ArrowRight;